export default function reducer(
  state = {
    status: '',
    error: null,

    tours_today: 0,
    history: {
      byid: {},
      list: [],
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1
    },
    typeahead: {
      staffId: [],
      device: [],
      name: [],
      zone: []
    },
    log: null,
    print: {
      byid: {},
      status: 'pending'
    },
    statistics: {
      status: 'pending',
      data: null
    }
  },
  action
) {
  let data;
  switch (action.type) {
    case 'CLEAR_STORE':
      state = defaultState();
      break;
    case 'TOURS_STATISTICS_COUNT':
      state = {
        ...state,
        tours_today: action.payload.data
      };
      break;

    case 'TOURS_FILTERED_HISTORY_FULFILLED':
    case 'TOURS_HISTORY_FULFILLED':
      data = action.payload.data;
      state = __tour_history(state, data);
      break;
    case 'TOURS_HISTORY_ITEMPERPAGE':
      state = __tour_history_pagination_itemPerPage(
        state,
        action.payload.count
      );
      break;
    case 'TOURS_HISTORY_CURRPAGE':
      data = action.payload.index;
      state = {
        ...state,
        history: {
          ...state.history,
          currentPage: data
        }
      };
      break;
    case 'TOURS_TYPEAHEAD_FULFILLED':
      state = __tour_typeahead(state, action.payload.data);
      break;
    case 'TOURS_HISTORY_CLEAR':
      state = {
        ...state,
        history: {
          ...state.history,
          byid: {},
          list: [],
          count: 0,
          total: 0,
          currentPage: 1,
          pageCount: 1
        }
      };
      break;
    case 'TOURS_LOG_FULFILLED':
      data = action.payload.data;
      state = {
        ...state,
        log: data
      };
      break;
    case 'TOURS_LOG_CLEAR':
      data = action.payload.data;
      state = {
        ...state,
        log: null
      };
      break;
    case 'TOURS_SET_PICTURE':
      state = update_default_picture(state, action.payload.id, action.payload.idx);
      break;
    case 'TOURS_PRINT_PENDING':
      data = action.payload.status;
      state = {
        ...state,
        print: {
          byid: {},
          list: [],
          status: 'pending'
        }
      };
      break;
    case 'TOURS_PRINT_FULFILLED':
      state = __tour_print(state, action.payload.data);
      break;
    case 'TOURS_STATISTICS_PENDING':
      state = {
        ...state,
        statistics: {
          ...state.statistics,
          status: 'pending',
          data: null
        }
      };
      break;
    case 'TOURS_STATISTICS_FULFILLED':
      state = compute_statistics(state, action.payload.response);
      /*
      state = {
        ...state,
        statistics: {
          ...state.statistics,
          status: 'fulfilled',
          data: action.payload.response
        }
      };
      */
      break;
    case 'TOURS_STATISTICS_REJECTED':
      state = {
        ...state,
        statistics: {
          ...state.statistics,
          status: 'rejected',
          data: null
        }
      };
      break;
    default:
      return state;
  }
  return state;
}
function defaultState() {
  return {
    status: '',
    error: null,

    tours_today: 0,
    history: {
      byid: {},
      list: [],
      count: 0,
      total: 0,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: 1
    },
    typeahead: {
      staffId: [],
      device: [],
      name: [],
      zone: []
    },
    log: null,
    print: {
      byid: {},
      status: 'pending'
    },
    statistics: {
      status: 'pending',
      data: null
    }
  };
}

function __tour_history(state, data) {
  if (state.history.list.length < 1 || state.history.total !== data.total) {
    state = {
      ...state,
      history: {
        ...state.history,
        list: new Array(data.total).fill(-1)
      }
    };
  }
  let __list = [...state.history.list];
  __list.splice(data.skip, data.list.length, ...data.list);

  let pCount = Math.ceil(data.total / state.history.itemPerPage);
  if (pCount < 1) {
    pCount = 1;
  }
  state = {
    ...state,
    history: {
      ...state.history,
      byid: { ...state.history.byid, ...data.data },
      list: __list,
      total: data.total,
      pageCount: pCount
    }
  };
  state = {
    ...state,
    history: {
      ...state.history,
      count: state.history.list.length
    }
  };

  return state;
}
function __tour_history_pagination_itemPerPage(state, count) {
  let pCount = Math.ceil(state.history.total / count);
  if (pCount < 1) {
    pCount = 1;
  }
  state = {
    ...state,
    history: {
      ...state.history,
      itemPerPage: count,
      pageCount: pCount,
      currentPage: 1
    }
  };
  return state;
}
function __tour_typeahead(state, data) {
  let { typeahead, ..._state } = state;
  typeahead = data;
  _state = {
    ..._state,
    typeahead: typeahead
  };
  return _state;
}
function __tour_print(state, data) {
  console.log('__tour_print', data);
  let _byid = {};
  data.forEach(e => {
    _byid[e.id] = e;
  });
  console.log('__tour_print', _byid);
  let _state = {
    ...state,
    print: {
      byid: _byid,
      status: 'done'
    }
  };
  return _state;
}

function update_default_picture(state, id, idx) {
  let { history, ..._state } = state;
  let { byid, ..._history } = history;
  let { [id]: log, ..._byid } = byid;

  let useDefault = [...log.useDefault];
  useDefault[idx] = true;

  log = {
    ...log,
    useDefault: useDefault
  };
  _byid = {
    ..._byid,
    [id]: log
  };
  _history = {
    ..._history,
    byid: _byid
  };
  _state = {
    ..._state,
    history: _history
  };
  return _state;
}

function compute_statistics(state, data) {
  // console.log('compute_statistics', data);
  let stat = {
    pointIds: []
  };

  data.forEach(t => {
    // console.log(t);
    if (t.points.length < 1) {
      return;
    }

    let points = {};

    //record and remove duplicates
    if (t.points.length > t.count) {
      let _points = [];
      t.points.forEach(p => {
        // console.log(p);
        if (!points[p.serialNumber]) {
          points[p.serialNumber] = {
            ori: p,
            dup: []
          };
          _points.push(p);
        } else {
          points[p.serialNumber].dup.push(p);
          stat.pointIds.push(p.id);
        }
      });
      t.points = _points;
    }

    let ts = new Date(t.startTimestamp);
    let year = 'year_' + ts.getFullYear();
    let month = 'month_' + ts.getMonth();

    if (!stat[year]) {
      stat[year] = {
        [month]: {
          [t.section]: {
            color: t.color,
            points: t.count,
            rounds: 1,
            expected: t.count,
            clocked: 0
          }
        }
      };
      t.points.forEach(p => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1
            };
            stat[year][month][t.section].clocked += 1;
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1
            };
            stat[year][month][t.section][p.name].count += 1;
          }
        }
      });
      return;
    }

    let statYear = stat[year];
    if (!statYear[month]) {
      statYear[month] = {
        [t.section]: {
          color: t.color,
          points: t.count,
          rounds: 1,
          expected: t.count,
          clocked: 0
        }
      };
      t.points.forEach(p => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1
            };
            stat[year][month][t.section].clocked += 1;
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1;
            stat[year][month][t.section][p.name].count += 1;
          }
        }
      });
      return;
    }

    let statMonth = stat[year][month];
    if (!statMonth[t.section]) {
      statMonth[t.section] = {
        color: t.color,
        points: t.count,
        rounds: 1,
        expected: t.count,
        clocked: 0
      };
      t.points.forEach(p => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1;
            stat[year][month][t.section][p.name] = {
              count: 1
            };
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1;
            stat[year][month][t.section][p.name].count += 1;
          }
        }
      });
      return;
    }

    stat[year][month][t.section].rounds += 1;
    stat[year][month][t.section].expected += t.count;
    // stat[year][month][t.section].clocked += t.points.length;
    t.points.forEach(p => {
      if (!stat[year][month][t.section][p.name]) {
        if (p.isVisited) {
          stat[year][month][t.section].clocked += 1;
          stat[year][month][t.section][p.name] = {
            count: 1
          };
        }
      } else {
        if (p.isVisited) {
          stat[year][month][t.section].clocked += 1;
          stat[year][month][t.section][p.name].count += 1;
        }
      }
    });
  });

  const _state = {
    ...state,
    statistics: {
      ...state.statistics,
      status: 'fulfilled',
      data: { ...stat }
    }
  };
  return _state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/_tours.js